import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BannerCarousel = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    pauseOnHover: false,
    fade: true,
  };


  const bannerImages = [
    "images/home-banner-1.jpg",
    "images/home-banner-3.jpg",
    "images/home-banner-4.jpg",
    "images/home-banner-5.jpg"
  ];

  return (
    <div className="banner-carousel">
      <Slider {...settings}>
        {bannerImages.map((imgSrc, idx) => (
          <div key={idx}>
            <img
              src={imgSrc}
              alt={`Banner ${idx + 1}`}
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
              className="img-fluid carousel-image"
              
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BannerCarousel;
